import { getEditableField } from '../store/selectors';
export var buildApiPayloadPromoIdFromStore = function (params) {
    var state = params.store.getState();
    var typeField = getEditableField(state, 'type');
    var isPromoCampaign = typeField.value === 'promotion';
    if (!isPromoCampaign) {
        return { promoId: null };
    }
    var promoCodeField = getEditableField(state, 'promoId');
    return { promoId: promoCodeField.value };
};
export var buildStorePromoIdFromApiCampaign = function (_a) {
    var campaign = _a.campaign;
    return { promoId: { value: campaign.promoId || null } };
};
